"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initForgotPasswordPage = exports.showNewPasswordFields = void 0;
const hideLabel = () => {
  const label = document.getElementById('VerificationCode_label');
  if (label) {
    label.style.display = 'none';
  }
};
const hideEmailParent = () => {
  const email = document.getElementById('email');
  const parent = email === null || email === void 0 ? void 0 : email.parentElement;
  if (parent) {
    parent.style.display = 'none';
  }
};
const hideClaimsButton = () => {
  const claimsButton = document.getElementById('emailVerificationControl_but_change_claims');
  if (claimsButton) {
    claimsButton.style.display = 'none';
  }
};
const inlineSubmitButton = () => {
  const submitButton = document.getElementById('continue');
  if (submitButton) {
    submitButton.style.display = 'inline';
  }
};
const relabelEmailCodeButton = () => {
  const emailCodeButton = document.getElementById('emailVerificationControl_but_send_code');
  if (emailCodeButton) {
    emailCodeButton.textContent = 'Continue';
  }
};
const relabelVerifyCodeButton = () => {
  const verifyCodeButton = document.getElementById('emailVerificationControl_but_verify_code');
  if (verifyCodeButton) {
    verifyCodeButton.textContent = 'Continue';
  }
};
const modifySimpleModal = () => {
  const modalVerifyingBlurb = document.getElementById('verifying_blurb');
  if (modalVerifyingBlurb) {
    const messageSpan = document.createElement('span');
    messageSpan.setAttribute('class', 'q-inner-loading__message');
    messageSpan.textContent = 'Please wait while we process your information.';
    const circle = document.createElement('circle');
    circle.setAttribute('class', 'path');
    circle.setAttribute('cx', '50');
    circle.setAttribute('cy', '50');
    circle.setAttribute('r', '20');
    circle.setAttribute('fill', 'none');
    circle.setAttribute('stroke', 'currentColor');
    circle.setAttribute('stroke-width', '2');
    circle.setAttribute('stroke-miterlimit', '10');
    const spinner = document.createElement('svg');
    spinner.setAttribute('class', 'q-spinner q-spinner-mat q-spinner--hal q-spinner--orange');
    spinner.setAttribute('width', '56px');
    spinner.setAttribute('height', '56px');
    spinner.setAttribute('viewBox', '25 25 50 50');
    spinner.appendChild(circle);
    const messageBoxDiv = document.createElement('div');
    messageBoxDiv.setAttribute('class', 'q-inner-loading__message-box');
    messageBoxDiv.appendChild(spinner);
    messageBoxDiv.appendChild(messageSpan);
    modalVerifyingBlurb.replaceWith(messageBoxDiv);
  }
};
const showNewPasswordFields = show => {
  const newPasswordFields = document.getElementsByClassName('Password');
  for (const newPasswordField of newPasswordFields) {
    newPasswordField.style.display = show ? 'block' : 'none';
  }
};
exports.showNewPasswordFields = showNewPasswordFields;
const initForgotPasswordPage = () => {
  const verificationMessage = document.getElementById('emailVerificationControl_success_message');
  if (verificationMessage) {
    verificationMessage.style.marginBottom = '30px';
    const verificationMessageObserver = new MutationObserver(() => {
      var _a;
      if (verificationMessage.style.display !== 'none') {
        verificationMessage.style.display = 'block';
        hideLabel();
        const textContent = (_a = verificationMessage.textContent) !== null && _a !== void 0 ? _a : '';
        if (textContent.includes('Verification code has been sent') || textContent.includes('verification code was sent')) {
          hideEmailParent();
        } else if (textContent.includes('The code has been verified')) {
          hideClaimsButton();
          inlineSubmitButton();
          const registrationForm = document.getElementById('attributeVerification');
          if (registrationForm) {
            (0, exports.showNewPasswordFields)(true);
          }
        }
      }
    });
    verificationMessageObserver.observe(verificationMessage, {
      attributes: true,
      childList: true
    });
  }
  relabelEmailCodeButton();
  relabelVerifyCodeButton();
  modifySimpleModal();
};
exports.initForgotPasswordPage = initForgotPasswordPage;
//# sourceMappingURL=forgotPassword.js.map